import { render, staticRenderFns } from "./SummarizeCommentChart.vue?vue&type=template&id=5f6ea6d0&scoped=true&lang=true&"
import script from "./SummarizeCommentChart.vue?vue&type=script&lang=js&"
export * from "./SummarizeCommentChart.vue?vue&type=script&lang=js&"
import style0 from "./SummarizeCommentChart.vue?vue&type=style&index=0&id=5f6ea6d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6ea6d0",
  null
  
)

export default component.exports